const copyButton = document.querySelector('.copy_button');
const onelinerText = document.querySelector('.oneliner h3');
if(copyButton && onelinerText){
    copyButton.addEventListener('click', function () {
        copyToClipboard(onelinerText.textContent);
        const originalText = onelinerText.textContent;
        onelinerText.textContent = 'Bonus kopiert';
    
        setTimeout(function () {
            onelinerText.textContent = originalText;
        }, 3000);
    }); 
}

function copyToClipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
}